import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const listJukebox = async (tableId) => {
    Store.dispatch(loadingActions.loadingStart('jukebox.getlist'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/table/'+tableId+'/jukebox');
        Store.dispatch(loadingActions.loadingEnd('jukebox.getlist'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('jukebox.getlist'));
        return e.response.data;
    }
};

export const addJukebox = async (tableId, name, value) => {
    Store.dispatch(loadingActions.loadingStart('jukebox.addLink'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/'+tableId+'/jukebox', {
            name,
            value
        });
        Store.dispatch(loadingActions.loadingEnd('jukebox.addLink'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('jukebox.addLink'));
        return e.response.data;
    }
};

export const editJukebox = async (tableId, id, name, value) => {
    Store.dispatch(loadingActions.loadingStart('jukebox.editJukebox'));
    try {
        let resp = await axios.put(process.env.REACT_APP_HOST + '/table/'+tableId+'/jukebox/'+id, {
            name,
            value
        });
        Store.dispatch(loadingActions.loadingEnd('jukebox.editJukebox'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('jukebox.editJukebox'));
        return e.response.data;
    }
};

export const removeJukebox = async (tableId, id) => {
    Store.dispatch(loadingActions.loadingStart('jukebox.deleteJukebox'));
    try {
        let resp = await axios.delete(process.env.REACT_APP_HOST + '/table/'+tableId+'/jukebox/'+id);
        Store.dispatch(loadingActions.loadingEnd('jukebox.deleteJukebox'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('jukebox.deleteJukebox'));
        return e.response.data;
    }
};